import React, { ReactElement, useEffect, useMemo } from 'react';
import { useEntries, useFetchSingleNewsAssetsAction } from 'b2b-apps/shop/content/hooks';
import { LOADED_CONTENT_TYPE_ID } from 'b2b-common/core/content/newsroom/utils';
import { EnhancedComponentProps, EnhancedComponentType, InjectedProps, WrappedComponentType } from './';

const withContainer = (Component: WrappedComponentType): EnhancedComponentType => {
  const WithContainer = (props: EnhancedComponentProps): ReactElement => {
    const fetchSingleNewsAssetsAction = useFetchSingleNewsAssetsAction();
    const { componentData } = props;
    const entriesIds = useMemo(
      (): string[] => (
        Object.keys(componentData)
          .filter(
            (entryId) => componentData[entryId]
              .some((el: string) => el.includes(LOADED_CONTENT_TYPE_ID.assets)),
          )
      ),
      [componentData],
    );

    useEffect(
      () => {
        fetchSingleNewsAssetsAction(entriesIds);
      },
      [
        fetchSingleNewsAssetsAction,
        entriesIds,
      ],
    );

    const assetsData = useEntries(entriesIds);
    const linksAssets = useMemo(
      (): any[] => Array.isArray(assetsData) && assetsData
        .filter(asset => asset?.data?.type === 'URL'),
      [assetsData],
    );

    const filesAssets = useMemo(
      (): any[] => Array.isArray(assetsData) && assetsData
        .filter(asset => asset?.data?.type !== 'URL'),
      [assetsData],
    );

    if (!componentData || !assetsData) {
      return null;
    }

    const injectedProps: InjectedProps = {
      linksAssets,
      filesAssets,
    };

    return <Component {...props} {...injectedProps} />;
  };

  return WithContainer;
};

export { withContainer };
